// tslint:disable-next-line:file-name-casing
export enum ERoute {
    subPage = 'subPage',
}